import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Movies from "@/pages/movies/page";
import TvSeries from "@/pages/tvseries/page";
import Detail from "@/pages/detail/page";
import Search from "@/pages/search/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import About from "@/pages/about/page";
import Favorites from "@/pages/favorites/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "movies", element: <Movies /> },
      { path: "tvseries", element: <TvSeries /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "search", element: <Search /> },
      { path: "news", element: <News /> },
      { path: "news/detail/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "favorites", element: <Favorites /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;